import { render, staticRenderFns } from "./order-submission.vue?vue&type=template&id=ecdb00ec&scoped=true"
import script from "./order-submission.vue?vue&type=script&lang=js"
export * from "./order-submission.vue?vue&type=script&lang=js"
import style0 from "./order-submission.vue?vue&type=style&index=0&id=ecdb00ec&prod&lang=scss&scoped=true"
import style1 from "./order-submission.vue?vue&type=style&index=1&id=ecdb00ec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecdb00ec",
  null
  
)

export default component.exports